import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import CloseIcon from '@/assets/icons/close-button.svg?react';
import { useTranslator } from '@/hooks/useTranslator';

export const EarningsClaimCompleted: React.FC = (): React.ReactElement => {
  const navigate = useNavigate();
  const tr = useTranslator();

  const onClose = React.useCallback((): void => {
    navigate('/earnings');
  }, [navigate]);

  return (
    <Paper sx={styles.container} elevation={1}>
      <Box sx={styles.titleBar}>
        <Box />
        <IconButton color="inherit" onClick={onClose}>
          <CloseIcon fill="currentColor" />
        </IconButton>
      </Box>

      <Box display="flex" flexDirection="column" gap={2} px={8} mb={5}>
        <Typography fontSize={32} fontWeight="500" lineHeight="40px">
          {tr('EARNINGS_CLAIM_SUCCESS')}
        </Typography>
        <Typography fontSize={16} fontWeight={400} lineHeight="24px" color="custom.LightGray">
          {tr('CHECK_HISTORY_DESCRIPTION')}
        </Typography>

        <Box my={3}>
          <Button variant="dark" fullWidth={true} onClick={onClose}>
            {tr('DONE')}
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    width: 744,
    maxHeight: '100%',
    overflowY: 'auto',
  },
  titleBar: {
    display: 'flex',
    position: 'sticky',
    height: 24,
    mt: 4,
    mb: 2,
    px: 3,
    top: 0,
    alignItems: 'center',
    backgroundColor: 'custom.OffWhite',
    justifyContent: 'space-between',
    width: '100%',
    color: 'text.primary',
  },
};
